export default __webpack_public_path__ + "static/media/learose2-1440w.e799c576.avif";